import { render, staticRenderFns } from "./ThemeMode.vue?vue&type=template&id=5235af48&scoped=true"
import script from "./ThemeMode.vue?vue&type=script&lang=js"
export * from "./ThemeMode.vue?vue&type=script&lang=js"
import style0 from "./ThemeMode.vue?vue&type=style&index=0&id=5235af48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235af48",
  null
  
)

export default component.exports